import React from 'react';

const StatTile = ({ label, value, dark = true }) => {
  const isText = typeof value === 'string';
  return (
    <div
      className={`h-[85px] flex justify-between flex-col overflow-hidden border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${
        dark ? 'bg-blue-900 text-white' : 'bg-shoorah-ggg'
      }`}
    >
      <div className={`text-[14px] font-medium ${dark ? 'text-shoorah-darkBg' : 'text-gray-400 dark:text-shoorah-darkBg'}`}>
        {label}
      </div>
      <div
        title={isText ? value : undefined}
        className={`font-medium overflow-hidden truncate ${isText ? 'text-sm lg:text-base' : 'text-lg lg:text-2xl'} ${dark ? 'text-shoorah-darkBg' : 'text-black dark:text-shoorah-darkBg'}`}
      >
        {value ?? 0}
      </div>
    </div>
  );
};

const SectionCard = ({ title, children }) => (
  <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
    <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">{title}</h3>
    <div className="grid grid-cols-2 gap-3">{children}</div>
  </div>
);

const FitnessStats = ({ stats }) => {
  if (!stats) return null;

  const { workouts, workoutPlans } = stats;

  return (
    <div className="mb-6">
      <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4">
        Fitness Statistics
      </div>

      {/* Workouts Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
        <SectionCard title="Workouts">
          <StatTile label="Total Workouts" value={workouts?.total} />
          <StatTile label="Active Workouts" value={workouts?.active} />
          <StatTile label="Users Used Workout" value={workouts?.totalUsersUsedWorkout} />
          <StatTile
            label="Most Used Workout"
            value={workouts?.mostUsedWorkout?.workoutName ?? 'N/A'}
            dark={false}
          />
        </SectionCard>

        <SectionCard title="Workout Sessions">
          <StatTile label="Total Sessions" value={workouts?.sessions?.total} />
          <StatTile label="Completed" value={workouts?.sessions?.completed} />
          <StatTile label="Pending" value={workouts?.sessions?.pending} dark={false} />
        </SectionCard>
      </div>

      {/* Workout Plans Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <SectionCard title="Workout Plans">
          <StatTile label="Total Plans" value={workoutPlans?.total} />
          <StatTile label="Active Plans" value={workoutPlans?.active} />
          <StatTile label="Users With Plan" value={workoutPlans?.totalUsersWithPlan} />
          <StatTile
            label="Most Used Plan"
            value={workoutPlans?.mostUsedPlan?.planName ?? 'N/A'}
            dark={false}
          />
        </SectionCard>

        <SectionCard title="Plan Sessions">
          <StatTile label="Total Sessions" value={workoutPlans?.sessions?.total} />
          <StatTile label="Completed" value={workoutPlans?.sessions?.completed} />
          <StatTile label="Pending" value={workoutPlans?.sessions?.pending} dark={false} />
        </SectionCard>
      </div>
    </div>
  );
};

export default FitnessStats;
